<template lang="html">
<section id="testimonials" class="padded" v-if="home[currentLang].testimonials.length">
	<transition name="slide-fade">
	<div class="content" v-if="sectionLoaded">
		<p class="h1" v-html="home[currentLang].testimonialsTitle"></p>

		<div class="carousel" v-if="home[currentLang].testimonials.length > 2">
			<agile :dots="false" ref="testimonials" :options="options" :navButtons="true">
				<div class="slide" v-for="(testimonial,index) in home[currentLang].testimonials" :key="index">
					<Testimonial :testimonial="testimonial" />
				</div>
			</agile>
		</div>

		<div class="flex no-carousel" v-else>
			<div class="slide" v-for="(testimonial,index) in home[currentLang].testimonials" :key="index">
				<Testimonial :testimonial="testimonial" />
			</div>
		</div>

	</div>
	</transition>
</section>
</template>

<script>
import scrollBehavior  from '@/mixins/scrollBehavior.js'
import imgHandler  from '@/mixins/imgHandler.js'

const Testimonial = () => import( /* webpackChunkName: "Testimonial" */ './Testimonial.vue');

export default {
	mixins: [scrollBehavior, imgHandler],
	components: { Testimonial },
	props: ['home', 'site', 'currentLang'],
	data () {
		return {
			sectionLoaded: false,
			options: {
				responsive: [
				{
					breakpoint: 600,
						settings: {
							slidesToShow: 1
					}
				},

				{
					breakpoint: 900,
						settings: {
							slidesToShow: 3
						}
					}
				]
			}
		}
	},
	methods:{
		defineTarget(url){
			if(!url){
				return
			}
			window.open(url);
		},
		defineStyle(testimonial){
			let styleObject = {
					color: '#fff',
					backgroundColor: "#000",
				};
			if(testimonial.bgColor){
				styleObject.backgroundColor = testimonial.bgColor; 
			}
			if(testimonial.textColor){
				styleObject.color = testimonial.textColor; 
			}
			return styleObject;
		},
		definePostType(testimonial){
			if(!testimonial.postType && !testimonial.colorLogo){
				return
			}
			let mode = testimonial.colorLogo == "Sombre" ? "-d" : "-l";
			let path = require('@/assets/img/'+testimonial.postType+mode+'.svg');
			return {
				background: 'url("'+path+'") no-repeat center'
			};
		}
		
	},
	watch:{
		visible(visible){
			if(visible){
				this.sectionLoaded = true;
			}
		}
	},
}
</script>

<style lang="scss">
	#app #testimonials{
		overflow:hidden;
		.carousel{
			margin-bottom:4rem;
			.agile{
				padding-bottom: 5rem;
			}
		}
		.h1{
			font-family: 'surtSemiBold', Helvetica, Arial, sans-serif;
			color: rgba(20, 20, 20, 1);
			font-size: 2rem;
			max-width:900px;
			line-height: 1.1;
			text-align:center;
			margin: 0 auto 2rem auto;
			@media screen and (min-width:768px){
				margin: 2.5rem auto 6.666rem auto;
			}
		}

		.agile__list{
			width: 100%;
			@media screen and (min-width:767px){
				width: 125%;
			}
		}
		.slide--content:first-child{
			margin-left: 0;
		}
		.agile__actions{
			position: absolute;
			right: 0;
			bottom:0;
			button{
				background-color:transparent;
				border-radius:100%;
				border: 1px solid #000;
				width: 40px;
				height: 40px;
				margin:5px;
				cursor: pointer;
				-webkit-transition: background .3s ease;
				transition: background .3s ease;
				background: url('../assets/img/arrow-new.svg') no-repeat center;
				font-size:1px;
				color:transparent;
				&.agile__nav-button--next{
					-webkit-transform: rotate(180deg);
					transform: rotate(180deg);
				}
				&:hover{
					background-color:#f1f1f1;
				}
			}
		}
		
		.no-carousel{
			flex-wrap: nowrap;
			margin: 20px 0 105px 0;
			> *{
				.slide--content{
					width:100%;
				}
			}
			> .slide{
				margin: 0 10px
			}
			@media screen and (max-width:767px){
				flex-wrap: wrap;
				width: 100%;
				> .slide{
					margin: 10px 0;
				}
			}
			@media screen and (min-width:1200px){
				> *{
					flex: 0 0 auto;
				}
			}
		}
		@media screen and (max-width:767px){
			padding-top:0;
		}
	}
</style>
